export const MAXIMUM_SHIPPING_COST = 100000;
export const MAXIMUM_DISPLAY_OPTION_ITEMS = 2;
